import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {HistoryFooterBox} from "./boxes/history-footer.box";
import {IHistoryPaginatorViewModel} from "../../../services/gaming-history/models/paginator/history-paginator-view-model.interface";
import {observer} from "mobx-react";
import {LoadingDotsComponent} from "../../../basic-components/loading-dots/loading-dots.component";

interface GamingHistoryFooterComponentProps {
    paginator: IHistoryPaginatorViewModel;
}

export const HistoryFooterComponent = observer(
    class HistoryFooterComponent extends OrbitComponent<GamingHistoryFooterComponentProps> {

        private _renderNoMoreRecordsMessage() {
            if(this.props.paginator.isLoading) {
                return null;
            }
            if(this.props.paginator.hasMoreRecords) {
                return null;
            }

            return this.services.translation.translate('GAMING_HISTORY_LAST_PAGE');
        }

        private _renderNoHistoryRecordsMessage() {
            if(this.props.paginator.isLoading) {
                return null;
            }

            if(this.props.paginator.records.length > 0) {
                return null;
            }

            return this.services.translation.translate('GAMING_HISTORY_NO_RECORDS');
        }

        private _renderLoadingDots() {
            if(this.props.paginator.isLoading) {
                return (
                    <LoadingDotsComponent/>
                );
            }
            return null;
        }


        render() {
            return (
                <HistoryFooterBox>
                    {this._renderNoMoreRecordsMessage()}
                    {this._renderNoHistoryRecordsMessage()}
                    {this._renderLoadingDots()}
                </HistoryFooterBox>
            );
        }
    }
);